import api from '../api';

export default {
  namespaced: true,
  state: {
    userList: {
      // 用户
      beanList: [],
      total: 0,
    },
    createRoomUserList: {
      // 可开房用户
      beanList: [],
      total: 0,
    },
    autoCreateUserList: {
      // 一键创建账号记录
      beanList: [],
      total: 0,
    },
    userImeiLoginList: {
      // 用户指定设备登录列表
      beanList: [],
      total: 0,
    },
    userLevelConfigList: [], // 用户层级列表
    msgReceiveUserList: {
      // 在线玩家-推送列表
      beanList: [],
      total: 0,
    },
    userLabelList: [], // 用户标签列表
    userWeightingList: {
      beanList: [],
      total: 0,
    },
    userWeightingStatus: 0, // 加权数据开关状态
    userWeightingInfo: {
      userId: '', //用户显性ID
      nickName: '',
      userHid: '', //用户隐形ID
      weightingStatus: '7', //加权状态
    },
  },
  getters: {
    // 用户层级设置
    userLevelCanConfigList(state) {
      let arr = [];
      return state.userLevelConfigList.filter((item) => {
        if (arr.indexOf(item.levelCode) < 0) {
          arr.push(item.levelCode);
          return item;
        }
      });
    },
    // 用户层级
    userLevelArr(state) {
      let arr = {
        6: 'T名单',
      };
      state.userLevelConfigList.forEach((item) => {
        arr[item.levelCode] = item.levelShowName;
      });
      return arr;
    },
    // 分值和用户层级
    userScoreAndLevel(state) {
      let arr = [];
      state.userLevelConfigList.forEach((item) => {
        arr[`${item.levelScore},${item.levelCode}`] = `${item.levelScore}/${item.levelShowName}`;
      });
      return arr;
    },
    userLevelOptions(state) {
      return state.userLevelConfigList.map((item) => {
        let label;
        if (item.levelScore !== null) {
          label = `${item.levelScore}/${item.levelShowName}`;
        } else {
          label = `${item.levelShowName}`;
        }
        return {
          label,
          value: `${item.levelScore},${item.levelCode}`,
        };
      });
    },
    userLabelOptions(state) {
      if (state.userLabelList.length !== 0) {
        return state.userLabelList.map((item) => {
          console.log('+++++++++++++++++++++++++++');
          console.log(item);
          return {
            label: item.name,
            value: item.id,
          };
        });
      }
    },
  },
  mutations: {
    setStateUserList(state, info) {
      state.userList = info;
    },
    setStateCreateRoomUserList(state, info) {
      state.createRoomUserList = info;
    },
    setStateAutoCreateUserList(state, info) {
      state.autoCreateUserList = info;
    },
    setStateUserImeiLoginList(state, info) {
      state.userImeiLoginList = info;
    },
    setStateUserLevelConfigList(state, info) {
      state.userLevelConfigList = info;
    },
    setStateMsgReceiveUserList(state, info) {
      state.msgReceiveUserList = info;
    },
    setStateUserLabelList(state, info) {
      state.userLabelList = info;
    },
    setStateUserWeightingList(state, info) {
      state.userWeightingList = info;
    },
    setStateUserWeightingStatus(state, info) {
      state.userWeightingStatus = info;
    },
    setUserWeightingInfo(state, info) {
      state.userWeightingInfo = info;
    },
  },
  actions: {
    updateUserState(store, params) {
      return api.post(`/usermemger/updateUserStatus`, '更新玩家的状态：停用或者启用', params);
    },
    updateWalletClose(store, params) {
      return api.post(`/usermemger/wallet/close`, '冻结钱包', params);
    },
    updateWalletOpen(store, params) {
      return api.post(`/usermemger/wallet/open`, '启用钱包', params);
    },
    setLoginAllow(store, params) {
      return api.post(`/usermemger/login/allow`, '允许登录', params);
    },
    setLoginForbid(store, params) {
      return api.post(`/usermemger/login/forbid`, '禁止登录', params);
    },
    getUserList({ commit }, params) {
      return api.post(`/usermemger/userInfoList`, '玩家列表', params).then((res) => {
        commit('setStateUserList', res.data);
      });
    },
    getCreateRoomUserList({ commit }, params) {
      return api
        .post(`/usermemger/createRoomUserList`, '开房权限的玩家列表', params)
        .then((res) => {
          commit('setStateCreateRoomUserList', res.data);
        });
    },
    openCreateRoomOp(store, userId) {
      return api.post(`/usermemger/openCreateOp/${userId}`, '添加玩家开房权限');
    },
    closeCreateRoomOp(store, params) {
      return api.post(`/usermemger/closeCreateRoomOp`, '关闭玩家创建牌局的权限', params);
    },
    checkUser(store, userHIdLst) {
      return api.post(`/usermemger/check/byhid`, '检查玩家是否存在', userHIdLst);
    },
    createUsers(store, params) {
      return api.post(`/usermemger/autoCreateUser`, '自动创建用户', params);
    },
    getAutoCreateUserList({ commit }, params) {
      return api.post(`/usermemger/autoCreateUserList`, '自动创建用户记录', params).then((res) => {
        commit('setStateAutoCreateUserList', res.data);
      });
    },
    addUserImeiLogin(store, params) {
      return api.post(`/user/imei/login/add`, '用户指定设备机器码登录 - 添加', params);
    },
    updateUserImeiLogin(store, params) {
      return api.post(`/user/imei/login/updateOne`, '用户指定设备机器码登录 - 更新单个', params);
    },
    deleteUserImeiLogin(store, params) {
      return api.post(`/user/imei/login/delete`, '用户指定设备机器码登录 - 删除', params);
    },
    getUserImeiLoginList({ commit }, params) {
      return api.post(`/user/imei/login/list`, '指定设备机器码登录 - 列表', params).then((res) => {
        commit('setStateUserImeiLoginList', res.data);
      });
    },
    getUserLevelConfigList({ commit }) {
      return api.post(`/usermemger/userLevelConfigList`, '用户层次配置列表').then((res) => {
        commit('setStateUserLevelConfigList', res.data);
      });
    },
    updateUserLevelConfig(store, params) {
      return api.post(`/usermemger/userLevelConfigEdit`, '用户层次配置编辑', params);
    },
    getMsgReceiveUserList({ commit }, params) {
      return api.post('/usermemger/msgReceiveUserList', '推送消息用户列表', params).then((res) => {
        commit('setStateMsgReceiveUserList', res.data);
      });
    },
    addMsgReceiveUser(store, params) {
      return api.post(`/usermemger/msgReceiveUser/add`, '添加推送列表', params);
    },
    deleteMsgReceiveUser(store, params) {
      return api.post(`/usermemger/msgReceiveUser/del`, '删除推送列表成员', params);
    },
    getUserInfo(store, params) {
      return api.post(`/usermemger/checkUserByUserNickNameOrId`, '查找用户', params);
    },
    updateUserData(store, params) {
      return api.post(`/user/data/edit`, '用户数据编辑', params);
    },
    getNewUserData(store, params) {
      return api.post('/usermemger/getNewUserData', '新增用户查询', params);
    },
    getUserLabelList({ commit }, params) {
      return api.post('/user/label/listConfigs', '标签列表', params).then((res) => {
        commit('setStateUserLabelList', res.data);
      });
    },
    addUserLabel(store, params) {
      return api.post('/user/label/addConfig', '新增标签', params);
    },
    updateUserLabel(store, params) {
      return api.post('/user/label/updateConfig', '更新标签名称', params);
    },
    deleteUserLabel(store, params) {
      return api.post('/user/label/deleteConfig', '删除标签配置', params);
    },
    setUserAddLabel(store, params) {
      return api.post('/user/label/add', '给用户添加标签', params);
    },
    getUserWeightingList({ commit }, params) {
      return api.post('/user/weighting/data', '用户加权数据', params).then((res) => {
        commit('setStateUserWeightingList', res.data);
      });
    },
    changeWeighting(store, params) {
      return api.post('/user/weighting/switchStatus', '加权统计开关', params);
    },
    searchWeightingStatus({ commit }, params) {
      return api.post('/user/weighting/queryStatus', '加权统计状态查询', params).then((res) => {
        commit('setStateUserWeightingStatus', res.data);
      });
    },
    getUserWeightingInfo({ commit }, userId) {
      return api.post(`/user/weighting/${userId}`, '获取加权信息').then((res) => {
        commit('setUserWeightingInfo', res.data);
      });
    },
    setWeighting(params) {
      return api.post('/user/weighting/manualSet', '确认加权', params).then(() => {});
    },
    cancelWeighting(params) {
      return api.post('/user/weighting/cancel', '取消加权', params).then(() => {});
    },
    addPrivilegeUser(store, params) {
      return api.post('/user/privilege/addPrivilegeUser', '新增特权玩家', params);
    },
    queryPrivilegeUser(store, params) {
      return api.post('/user/privilege/queryPrivilegeUser', '查询特权玩家', params);
    },
    deletePrivilegeUser(store, params) {
      return api.post('/user/privilege/deletePrivilegeUser', '删除特权玩家', params);
    },
  },
};
